import BUNDLE_CONFIGS from '../../data/bundle-active-config.json'
import DefaultConfig from './defaultConfig'
import {
  ResponseStatusCodes, ResponseHandlers,
} from './enums'
import { INITIAL_SCHEMA_VERSION_NUMBER, LOCALSTORAGE_ACTIVE_CONFIG_KEY } from './constants'
import { ActiveConfigType, BundleConfigType } from '../utils/dataTypes'
import { IActiveConfig, IStaticActiveConfig } from './interfaces'
import PsmBridge from './psm-bridge'

class ActiveConfig extends IStaticActiveConfig implements IActiveConfig {
  bundleConfig: BundleConfigType = BUNDLE_CONFIGS
  static currentVersion: string = INITIAL_SCHEMA_VERSION_NUMBER
  static activeConfig: ActiveConfigType | BundleConfigType
  updateCurrentVersion: (version: string) => void

  // TODO: Move this to a more appropriate location - should this be set in the player file? Doc says "A very basic config is stored in the SDK bundle that is immediately overridden by the Config Class"
  static responseProcessorConfig = [
    {
      code: ResponseStatusCodes.Code201Created,
      handlerFunction: ResponseHandlers.Success,
    },
    {
      code: ResponseStatusCodes.Code400BadRequest,
      handlerFunction: ResponseHandlers.Failure,
    },
    {
      code: ResponseStatusCodes.Code999Test,
      handlerFunction: ResponseHandlers.Retry,
    },
  ]

  constructor() {
    super()
  }

  static updateCurrentVersion(version: string): void {
    this.currentVersion = version
  }

  getLocalStorageConfig(): void {
    const storeUnresolved: Promise<string | undefined> | string = PsmBridge.dependencies?.getLocalStorage(LOCALSTORAGE_ACTIVE_CONFIG_KEY)

    switch (typeof storeUnresolved) {
      case 'string':
        ActiveConfig.activeConfig = !!storeUnresolved ? JSON.parse(storeUnresolved) : this.bundleConfig
        ActiveConfig.updateCurrentVersion(ActiveConfig.activeConfig.version)
        break;
      case 'object':
        storeUnresolved.then(data => {
          ActiveConfig.activeConfig = !!data ? JSON.parse(data) : this.bundleConfig
          ActiveConfig.updateCurrentVersion(ActiveConfig.activeConfig.version)
        })
        break;
      default:
        ActiveConfig.activeConfig = this.bundleConfig
        ActiveConfig.updateCurrentVersion(ActiveConfig.activeConfig.version)
        break;
    }
  }

  setLocalStorageConfig(data: ActiveConfigType | null): void {
    PsmBridge.dependencies.setLocalStorage(LOCALSTORAGE_ACTIVE_CONFIG_KEY, data)
  }

  async updateLocalStorageConfig(newVersion: string): Promise<void> {
    let isSameVersion: boolean = ActiveConfig.activeConfig?.version === newVersion

    if (!isSameVersion) {
      const newConfig = new DefaultConfig(newVersion)
      const defaultConfig: ActiveConfigType | null = await newConfig.refreshConfig()
      if (defaultConfig) {
        this.setLocalStorageConfig(defaultConfig)
      } else {
        this.setLocalStorageConfig(ActiveConfig.activeConfig)
      }
    } else {
      this.setLocalStorageConfig(ActiveConfig.activeConfig)
    }
    this.getLocalStorageConfig()
  }
}

export default ActiveConfig
